module.exports = __webpack_public_path__ + "static/img/s_banner3.d279a7dd.png";